@if (messages | async; as notifications) {
<div class="warning-message" [@notificationList]="notifications.length">
  @for (notification of notifications; track notification) {
  <alert
    [type]="notification.type"
    [dismissOnTimeout]="notification.timeout"
    [dismissible]="notification.dismissible"
  >
    <span
      [innerHtml]="notification.message | globalTranslate | sanitize"
      role="alert"
      aria-live="assertive"
      [attr.aria-label]="notification.message | sanitize"
    ></span>
  </alert>
  }
</div>
}